/*
 * Loading Indicator component to be used for long backend calls
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'reporter-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    standalone: false
})
export class LoadingIndicatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
